<template>
  <button
    type="button"
    class="relative ml-2.5 cursor-pointer text-order-buttons after:absolute after:bottom-0 after:left-1/2 after:h-px after:w-full after:origin-center after:-translate-x-1/2 after:bg-current after:transition-transform after:duration-150 hover:after:scale-x-0"
  >
    <span
      class="text-sm font-bold"
      v-text="$t('pages.category.product_filters.explanation_name')"
    />
  </button>
</template>

<script setup lang="ts"></script>
